/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DetailDropdowns
 */
export interface DetailDropdowns {
  /**
   *
   * @type {Array<string>}
   * @memberof DetailDropdowns
   */
  timePeriod?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof DetailDropdowns
   */
  benificiaryType?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof DetailDropdowns
   */
  product?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof DetailDropdowns
   */
  coverageStatus?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof DetailDropdowns
   */
  compCoverageStatus?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof DetailDropdowns
   */
  relativeStatus?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof DetailDropdowns
   */
  indication?: Array<string> | null;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof DetailDropdowns
   */
  productIndicationMap?: { [key: string]: Array<string> } | null;
}

export function DetailDropdownsFromJSON(json: any): DetailDropdowns {
  return DetailDropdownsFromJSONTyped(json, false);
}

export function DetailDropdownsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DetailDropdowns {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    timePeriod: !exists(json, "timePeriod") ? undefined : json["timePeriod"],
    benificiaryType: !exists(json, "benificiaryType") ? undefined : json["benificiaryType"],
    product: !exists(json, "product") ? undefined : json["product"],
    coverageStatus: !exists(json, "coverageStatus") ? undefined : json["coverageStatus"],
    compCoverageStatus: !exists(json, "compCoverageStatus") ? undefined : json["compCoverageStatus"],
    relativeStatus: !exists(json, "relativeStatus") ? undefined : json["relativeStatus"],
    indication: !exists(json, "indication") ? undefined : json["indication"],
    productIndicationMap: !exists(json, "productIndicationMap") ? undefined : json["productIndicationMap"],
  };
}

export function DetailDropdownsToJSON(value?: DetailDropdowns | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    timePeriod: value.timePeriod,
    benificiaryType: value.benificiaryType,
    product: value.product,
    coverageStatus: value.coverageStatus,
    compCoverageStatus: value.compCoverageStatus,
    relativeStatus: value.relativeStatus,
    indication: value.indication,
    productIndicationMap: value.productIndicationMap,
  };
}
